import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getFundingSources } from '../../services/AccountApi/paymentMethodApi';
import { toastNotify } from '../../utils/toastNotify';

const initialState = {
  loading: false,
  banks: [],
  wallets: [],
  walletBalance: null,
  availableBalance: null,
  isBankInFundingSource: false,
  error: null,
};

export const fetchFundingSourcesAction = createAsyncThunk(
  'FETCH_FUNDING_SOURCES',
  async (_, { rejectWithValue }) => {
    try {
      const resp = await getFundingSources();
      if (!resp.isError) {
        return resp.data;
      }
      return rejectWithValue(resp?.message);
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const fundingSourcesSlice = createSlice({
  name: 'fundingSources',
  initialState,
  extraReducers: {
    [fetchFundingSourcesAction.pending]: (state) => {
      return { ...state, loading: true, error: null };
    },
    [fetchFundingSourcesAction.fulfilled]: (state, action) => {
      const { banks = [], wallets = [] } = action.payload || {};
      const wallet = wallets?.[0];
      return {
        ...state,
        loading: false,
        banks,
        wallets,
        isBankInFundingSource: banks.length > 0,
        walletBalance: wallet?.balance ?? null,
        availableBalance: wallet?.availableBalance ?? null,
        error: null,
      };
    },
    [fetchFundingSourcesAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return { ...state, loading: false, error: action.payload };
    },
  },
});

export default fundingSourcesSlice.reducer;
